const styles = theme => ({
  icon: {
    color: theme.color.tundora,
    display: 'block',
    marginRight: '15px',
  },
});

export default styles;
